import { useQuery } from '@tanstack/react-query';
import { caseApplicationsService, GET_STEPS } from '@/api';

export const useCaseSteps = (caseId?: string) =>
	useQuery({
		queryKey: [GET_STEPS],
		queryFn: () => caseApplicationsService.getSteps(caseId || ''),
		enabled: !!caseId,
	});
